module.exports = __webpack_public_path__ + "img/epiito_logo_lightBlue.83540a24.png";